import React from 'react';
import { formatCurrency } from '../../../../../../../../../../utils/functions';
import './PaymentSummary.scss';

interface PaymentTypeSummary {
  count: number;
  amount: number;
  tip_amount: number;
  net_amount: number;
}

interface PaymentSummaryProps {
  typeSummary: { [paymentType: string]: PaymentTypeSummary };
}

const PaymentSummary: React.FC<PaymentSummaryProps> = ({ typeSummary }) => {
  return (
    <div className="sb-section">
      <h4 className="sb-section-title">Formas de Pago</h4>
      {Object.entries(typeSummary).map(([paymentType, summary]) => (
        <div key={paymentType} className="sb-row">
          <span className="sb-label">{paymentType}</span>
          <span className="sb-value">{formatCurrency(summary.amount)}</span>
        </div>
      ))}
    </div>
  );
};

export default PaymentSummary;
